import { useLocation } from 'react-router-dom'

export const useUrlQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const useUrlSearchQuery = () => {
  const searchQuery = useLocation().search.replace('?', '')

  if (searchQuery === '') return {}

  const parsedSearchQuery = searchQuery
    .split('&')
    .map((pair) => pair.split('='))
    .reduce((acc: Record<string, string>, [key, value]) => {
      acc[decodeURIComponent(key)] = decodeURIComponent(value)
      return acc
    }, {} as Record<string, string>)

  return parsedSearchQuery
}
